import { useState } from "react";
import DeeperLookIcon_Trans from "../../../assets/UI/DeeperLookIcon_Trans.png";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";
import "../DeeperLook.css"; 

export default function NumbersDLook() {

const categories = {

     Numbers_DL_Overview: {
 
         title: "Overview",
         content:[
                 { type: "subheader", content: "Introduction" },
                 { type: "paragraph", content: "Numbers are an essential part of Korean, used in daily life for telling time, counting money, giving phone numbers, and much more. What makes Korean numbers interesting is that there are actually two number systems:" },
                 { type: "list", items: ["Native Korean numbers (하나, 둘, 셋 …)", "Sino-Korean numbers (일, 이, 삼 …, borrowed from Chinese)"] },
                 { type: "paragraph", content: "Each system is used in different situations, so learning when to use which one is just as important as memorizing the numbers themselves. This deck will help you build a strong foundation and give you plenty of practice in real-life contexts." },
        ]
     },
     
         
      Numbers_DL_NativeKoreanNumbersTxt:{ 
         
         title: "Native Korean Numbers",
         content:[    
             { type: "subheader", content: "Using Native Korean Numbers" },
             { type: "paragraph", content: "Native Korean numbers are the original Korean counting system. They’re usually used for counting things, people, and hours of time (but not minutes). These numbers only go up to 99—after that, Sino-Korean numbers are used." },
             { type: "paragraph", content: "Here are the first ten:" },
             { 
                 type: "table", 
                 rows: [
                     ["Number", "Native Korean Number"], 
                     ["1", "하나 (ha-na)"],
                     ["2", "둘 (dul)"],
                     ["3", "셋 (set)"],
                     ["4", "넷 (net)"],
                     ["5", "다섯 (da-seot)"],
                     ["6", "여섯 (yeo-seot)"],
                     ["7", "일곱 (il-gop)"],
                     ["8", "여덟 (yeo-deol)"],
                     ["9", "아홉 (a-hop)"],
                     ["10", "열 (yeol)"]
                 ]
             },
             { type: "subheader", content: "Counting"},
             { type: "paragraph", content: "When Native numbers are used before counters (like “three apples”), they often shorten:"},
             { type: "list", items: 
                [
                    "하나 → 한", 
                    "둘 → 두", 
                    "셋 → 세",
                    "넷 → 네"     
                ] 
            },
            { type: "paragraph", content: "Example:"},
            { type: "list", items: 
                [
                    "사과 한 개 → one apple", 
                    "사람 두 명 → two people"   
                ] 
            },
            { type: "list", items: 
                [
                    "11 → 십일 (sip-il)", 
                    "20 → 이십 (i-sip)", 
                    "25 → 이십오 (i-sip-o)",
                    "100 → 백 (baek)",
                    "1,000 → 천 (cheon)"
                ] 
            },
            { type: "paragraph", content: "Example Uses:"},
            { type: "list", items: 
                [
                    "전화번호: 010-1234-5678 → 공-일-공 / 일-이-삼-사 / 오-육-칠-팔", 
                    "가격: 삼천 원 → 3,000 won", 
                ] 
            },
         ]
     },
 
     Numbers_DL_WhenToUseEachSystemTxt:{
         
         title: "When to Use Each System",
         content:[    
             { type: "subheader", content: "How to Choose" },
             { type: "paragraph", content: "Korean uses two number systems, and the trick is knowing which situations call for Native vs. Sino-Korean numbers." },
             { type: "paragraph", content: "Native Korean Numbers are used for:" },
             { type: "list", items: 
                [
                    "Counting objects → 사과 세 개 (three apples)", 
                    "Counting people → 사람 두 명 (two people)", 
                    "Hours of time (but not minutes) → 세 시 (3 o’clock)",
                    "Age (traditional way) → 스무 살 (20 years old)"
                ] 
             },
             { type: "paragraph", content: "Sino-Korean Numbers are used for:" },
             { type: "list", items: 
                [
                    "Dates → 이월 십오일 (February 15th)", 
                    "Money → 천 원 (1,000 won)", 
                    "Phone numbers → 공일공 (010)",
                    "Minutes & seconds → 십오 분 (15 minutes), 십초 (10 seconds)",
                    "Addresses & room numbers → 삼층 (3rd floor), 이호선 (Line 2 subway)",
                    "Math & large numbers → 백 (100), 천 (1,000), 만 (10,000)"
                ] 
             },
             { type: "paragraph", content: "If you’re ever unsure, think:" },
             { type: "list", items: 
                [
                    "Am I counting things or hours?” → Native Korean.", 
                    "Am I saying numbers on paper (like dates, prices, or phone numbers)?” → Sino-Korean.", 
                ] 
              }
             
         ]
     },
 
     Numbers_DL_CoutingObjectsWithCounters: {
     
         title: "Counting Objects with Counters",
         content:[    
             { type: "subheader", content: "1,2,3..." },
             { type: "paragraph", content: "In Korean, you don’t just put a number before a noun—you use special words called counters. Counters show what kind of thing you’re counting." },
             { type: "subheader", content: "Common Counters:" },
             { type: "list", items: 
                [
                    "개 (gae) → general counter for things", 
                    "명 (myeong) → people", 
                    "마리 (mari) → animals",
                    "권 (gwon) → books",
                    "잔 (jan) → cups/glasses of drinks",
                    "대 (dae) → vehicles, machines"

                ] 
              },
              { type: "subheader", content: "How It Works" },
              { type: "list", items: 
                [
                    "사과 세 개 → three apples", 
                    "학생 두 명 → two students", 
                    "고양이 한 마리 → one cat",
                    "책 다섯 권 → five books"
                ]
              },
              { type: "paragraph", content: "Always use Native Korean numbers with counters, not Sino-Korean." },
              { type: "subheader", content: "Try It Yourself!" },
              { type: "paragraph", content: "Look around your room and try counting things in Korean—like “책 세 권” (three books) or “컵 한 잔” (one cup)." },


         ]
     },
     
      Numbers_DL_EverydayExamples: {
        title: "Everyday Examples",
        content:[
             { type: "subheader", content: "Numbers In Our Everyday" },
             { type: "paragraph", content: "Numbers show up everywhere in daily life, so practicing them in real-world contexts helps you get comfortable using both systems." },
             { type: "subheader", content: "Time" },
             { type: "list", items: 
                [
                "세 시 십오 분 → 3:15 (Native for hours, Sino for minutes)", 
                "오전 열 시 → 10 a.m.", 
                ]
             },
             { type: "subheader", content: "Date" },
             { type: "list", items: 
                [
                "삼월 이십일 → March 20th", 
                "일월 일일 → January 1st", 
                ]
             },
             { type: "subheader", content: "Money" },
             { type: "list", items: 
                [
                "오천 원 → 5,000 won", 
                "만오백 원 → 10,500 won", 
                ]
             },
             { type: "subheader", content: "Phone Numbers" },
             { type: "list", items: 
                [
                "010-2345-6789 → 공-일-공 / 이-삼-사-오 / 육-칠-팔-구", 

                ]
             },
             { type: "subheader", content: "Everyday Use" },
             { type: "list", items: 
                [
                "버스 오 분 뒤에 와요 → The bus comes in 5 minutes.", 
                "삼층에 있어요 → It’s on the 3rd floor.", 
                ]
             },
             { type: "subheader", content: "Try It Yourself!" },
             { type: "paragraph", content: "Try practicing by reading clocks, price tags, or addresses out loud in Korean—it makes the numbers stick quickly." },






             { type: "subheader", content: "Details" },
             { type: "list", items: ["1st", "2nd", "3rd"] },
 
             { type: "subheader", content: "Table" },
             { 
                 type: "table", 
                 rows: [
                     ["Term", "Definition"],
                     ["Item1", "Definition1"],
                     ["Item2", "Definition2"]
                 ]
             },
 
         ]
     },
     Numbers_CommonPhrasesWithNumbers: {
        title: "Common Phrases with Numbers",
        content:[
             { type: "subheader", content: "Common Phrases" },
             { type: "paragraph", content: "Numbers often appear in set expressions or everyday phrases. These are useful to memorize because you’ll hear them frequently in conversation." },
             { type: "subheader", content: "Frequency & Repetition" },
             { type: "list", items: 
                [
                "한 번 → once / one time", 
                "두 번 → twice", 
                "세 번 → three times"
                ]
             },
             { type: "subheader", content: "Time Expressions" },
             { type: "list", items: 
                [
                "하루 → one day", 
                "이틀 → two days", 
                "사흘 → three days (less common in daily speech, but good to know)"
                ]
             },
             { type: "subheader", content: "Everyday Phrases" },
             { type: "list", items: 
                [
                "잠깐만, 오 분만 기다려 주세요. → Just a moment, please wait 5 minutes.", 
                "한번 해 보세요. → Try it once.", 
                "세 번 말했어요. → I said it three times."
                ]
             },
             { type: "paragraph", content: "Expressions with numbers are often used in polite requests or everyday storytelling. Practice using “번” (times) when talking about things you do repeatedly." },
 
         ]
     }
 }
 
 
 
   //Make overveiw the default catgory selected when page loads
   const [selectedCategory, setSelectedCategory] = useState("Numbers_DL_Overview");
 
 
   return (
     <div>
       
       <HeaderNavNTM GoBack_to="/NumbersNav"/>
 
       <div className="blue-header-dlook">
         <img
           className="DeeperLookImage-dlook"
           src={DeeperLookIcon_Trans}
           alt="Deeper Look"
         />
       </div>

       <div className="panel-container-dlook">

         <div className="side-panel-dlook">
           {Object.keys(categories).map(key => (

             <p
               key={key}

               className={key === selectedCategory 
                 ? "category-active" 
                 : "category-inactive"}

               onClick={() => setSelectedCategory(key)}
             >              
               {categories[key].title}
             </p>
           ))}
         </div>
 
         {/* Text panel */}
     <div className="text-panel-dlook">
        {(categories[selectedCategory]?.content ?? []).map((item, index) => {

 
            switch (item.type) {

  
             case "subheader":
                 return <h3 key={index} className="subheader-dlook">{item.content}</h3>;
 
             case "paragraph":
                 return <p key={index}>{item.content}</p>;
 
             case "list":
                 return (
                 <ul key={index} className="list-dlook">
                     {item.items.map((bullet, i) => (
                     <li key={i}>{bullet}</li>
                     ))}
                 </ul>
                 );
 
             case "table":
                 return (
                 <table key={index} className="table-dlook">
                     <tbody>
                     {item.rows.map((row, r) => (
                         <tr key={r}>
                         {row.map((cell, c) => (
                             <td key={c}>{cell}</td>
                         ))}
                         </tr>
                     ))}
                     </tbody>
                 </table>
                 );
 
             default:
                 return null;

             }
             })}
         </div>
 
       </div>
      
       {/* End Body */}
     
     
     
     </div>
   );/* End return */
 } 
 
